import React from 'react';

import { HiddenInput, SwitchContainer } from '@aspid/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material/styles';

import { IconCollection } from '@components/icons/iconCollection';

import { StateLayer } from '../StateLayer';
import { Thumb } from '../Thumb';
import { Track } from '../Track';

import type { SwitchViewProperties } from './SwitchView.types';

export const SwitchView: React.FC<SwitchViewProperties> = ({
  isChecked,
  isDisabled,
  showIcons,
  stateLayerColor,
  onMouseEnter,
  onMouseLeave,
  onMouseDown,
  onMouseUp,
  onChange,
  inputProps,
  dataTest,
}) => {
  const theme = useTheme();

  const getIconColor = () => {
    if (isChecked) {
      return theme.palette.mode === 'dark'
        ? theme.palette.primary.contrastText
        : theme.palette.primary.main;
    }
    return theme.palette.mode === 'dark'
      ? theme.palette.grey[800]
      : theme.palette.grey[200];
  };

  return (
    <SwitchContainer
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      data-test={dataTest}
    >
      <Track
        isChecked={isChecked}
        isDisabled={isDisabled}
        data-test={dataTest ? `${dataTest}-track` : undefined}
      >
        <StateLayer
          isChecked={isChecked}
          sx={{ backgroundColor: stateLayerColor }}
          data-test={dataTest ? `${dataTest}-state-layer` : undefined}
        />
        <Thumb
          isChecked={isChecked}
          isDisabled={isDisabled}
          data-test={dataTest ? `${dataTest}-thumb` : undefined}
        >
          {showIcons && !isDisabled && (
            <FontAwesomeIcon
              icon={isChecked ? IconCollection.check : IconCollection.xmark}
              style={{
                fontSize: isChecked ? 14 : 10,
                color: getIconColor(),
              }}
            />
          )}
        </Thumb>
        <HiddenInput
          type='checkbox'
          checked={isChecked}
          disabled={isDisabled}
          onChange={onChange}
          data-test={dataTest ? `${dataTest}-input` : undefined}
          {...inputProps}
        />
      </Track>
    </SwitchContainer>
  );
};
